// .tsx on purpose: the apps' Tailwind content globs only scan libs/ui/src/**/*.tsx.
import { SizeVariant } from '@this+that/utils';

export type HitAreaSize = SizeVariant.SM | SizeVariant.MD | SizeVariant.LG;

const CONTROL = 'relative isolate hover:z-10';

const PSEUDO_SHAPE =
  "before:content-[''] before:absolute before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-full before:-z-10 before:bg-semantic-text-primary/10";

const PSEUDO_MOTION =
  'before:opacity-0 before:scale-75 before:pointer-events-none before:transition-[opacity,scale] before:duration-150';

const POINTER_FINE =
  'hover:before:opacity-100 hover:before:scale-100 hover:before:pointer-events-auto focus-visible:before:opacity-100 focus-visible:before:scale-100';

const POINTER_COARSE =
  'pointer-coarse:before:pointer-events-auto pointer-coarse:before:scale-100 pointer-coarse:active:before:opacity-100';

const BASE = [
  CONTROL,
  PSEUDO_SHAPE,
  PSEUDO_MOTION,
  POINTER_FINE,
  POINTER_COARSE,
].join(' ');

export const HIT_AREA_CLASS_NAMES: Record<HitAreaSize, string> = {
  [SizeVariant.SM]: `${BASE} before:w-8 before:h-8`,
  [SizeVariant.MD]: `${BASE} before:w-9 before:h-9`,
  [SizeVariant.LG]: `${BASE} before:w-10 before:h-10`,
};
